import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18next from 'i18next';
import enTranslation from './json/en.json';
import esTranslation from './json/es.json';

const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';

i18next.init({
    lng: selectedLanguage, 
    fallbackLng: 'en',
    debug: true,
    resources: {
        en: {
            translation: enTranslation
        },
        es: {
            translation: esTranslation
        }
    }
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
